var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgZtaSirensirentrue = function SvgZtaSirensirentrue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    stroke: "currentColor",
    strokeLinejoin: "round",
    transform: "translate(0 -1020.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3994",
    fill: "currentColor",
    strokeWidth: 2.114,
    d: "M1.057 1031.1h6.459l8.807-8.22v27.009l-8.807-8.22h-6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3997",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 3.171,
    d: "M26.305 1025.8s4.11 3.146 4.11 10.569-4.11 10.569-4.11 10.569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2.349,
    d: "M22.429 1029s2.989 2.39 2.989 7.517-2.989 7.28-2.989 7.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4001",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.762,
    d: "M18.672 1032.3s2.335 1.45 2.335 4.177-2.335 4.043-2.335 4.043"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZtaSirensirentrue);
export default ForwardRef;